import firebase from "firebase";
import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import LoginPage from "../components/Pages/LoginPage";
import ResetPage from "../components/Pages/ResetPage";
import styled from "styled-components";
import background2 from "../assets/img/background-2.jpg";
import "./index.css";

const BeautifulLogin = () => {
  const [view, setView] = useState("login");
  const [showBanner, setShowBanner] = useState({
    message: "",
    show: false,
    type: "success",
  });

  const mailSignin = async (data) => {
    const { email, password } = data;
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
      window.location.href = "/";
    } catch (error) {
      setShowBanner({ message: error.message, show: true, type: "error" });
    }
  };

  const resetPassword = async (data) => {
    const { email } = data;
    try {
      await firebase.auth().sendPasswordResetEmail(email);
      setShowBanner({
        message: "Check your email and follow the steps to reset your password",
        show: true,
        type: "success",
      });
    } catch (error) {
      setShowBanner({
        message: error.message,
        show: true,
        type: "error",
      });
    }
  };

  const Wrapper = styled.div`
    align-content: center;
    display: grid;
    height: 100vh;
    justify-content: center;
    position: relative;
    width: 100%;
    background: radial-gradient(
        218.51% 281.09% at 100% 100%,
        rgba(41, 128, 185, 0.5) 0%,
        rgba(109, 213, 250, 0.3) 45.83%,
        rgba(255, 255, 255, 0.2) 100%
      ),
      url(${background2});
    background-position: center;
    background-size: cover;
  `;

  const selectedView = () => {
    switch (view) {
      case "login":
        return <LoginPage handleView={setView} mailSignin={mailSignin} />;
      default:
        return <ResetPage handleView={setView} resetPassword={resetPassword} />;
    }
  };

  useEffect(() => {
    setShowBanner({ message: "", show: false, type: "success" });
  }, [view]);

  return (
    <Wrapper>
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {showBanner.show && (
          <Banner message={showBanner.message} type={showBanner.type} />
        )}
        {selectedView()}
      </div>
    </Wrapper>
  );
};

export default BeautifulLogin;



// WEBPACK FOOTER //
// ./src/components/login/widget/BeautifulLogin.js